import styled from "styled-components";

export const StyledFeatureCardContainer = styled.div`
  /* background: var(--backgroundModalTransparent); */
  /* backdrop-filter: var(--backdropFilter); */
  background: rgba(255, 255, 255, 0.5);
  padding: 4px 8px 4px;
  border-radius: 4px;
  cursor: pointer;

  :not(:last-child) {
    /* border-bottom: 1px solid #eee; */
  }
`;

export const StyledFeatureCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  span {
    font-size: 12px;
    line-height: normal;
  }
`;

export const StyledFeatureImageContainer = styled.div`
  width: 22px;
  height: 22px;
  min-width: 16px;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const StyledFeatureCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  margin-top: 2px;

  span {
    line-height: normal;
    font-size: 12px;
  }
`;

export const StyledFeatureCardFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;

  margin-top: 8px;
  /* padding-top: 4px; */
`;
